"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.required = required;
exports.min = min;
exports.max = max;
exports.regex = regex;
exports.number = number;
exports.email = email;
exports.matches = matches;
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _check = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/check-2"));

var _warning = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/warning"));

var _security = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/security"));

var _underscore = _interopRequireDefault(require("underscore"));

var _reactBootstrap = require("react-bootstrap");

var _TextArea = _interopRequireDefault(require("../TextArea/TextArea"));

var _Select = _interopRequireDefault(require("../Select/Select"));

require("./InputField.less");

var _trim = _interopRequireDefault(require("../../utils/trim"));

var _Validation = require("./Validation");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function required(value) {
  return !_underscore.default.isUndefined(value) && value !== '';
}

function min(length) {
  return function (value) {
    return _underscore.default.isUndefined(value) || value.length >= length;
  };
}

function max(length) {
  return function (value) {
    return _underscore.default.isUndefined(value) || value.length <= length;
  };
}

function regex(regex) {
  return function (value) {
    return _underscore.default.isUndefined(value) || regex.test(value);
  };
}

function number(value) {
  return regex(/^\d*$/)(value);
}

function email(value) {
  return regex(/^[^@]+@[^@]+\.[^.@]+$/)(value);
}

function matches(otherValue) {
  return function (value) {
    return value === otherValue;
  };
}

var InputField = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputField, _Component);

  var _super = _createSuper(InputField);

  function InputField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputField);
    _this = _super.call(this, props);
    var value = props.value,
        valid = props.valid;
    _this.state = {
      value: value,
      visited: !_underscore.default.isUndefined(value) && (_this.props.validateEmpty || _this.props.required === false || value !== ''),
      valid: valid,
      focused: false,
      blurred: true,
      errorQueue: false
    };
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InputField, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var value = _ref.value,
          valid = _ref.valid;
      var changed = false;
      var state = {};

      if (!_underscore.default.isUndefined(value) && value !== this.state.value) {
        changed = true;
        state.value = value;
        value === '' ? state.visited = false : state.visited = true;
      }

      if (!_underscore.default.isUndefined(valid)) {
        changed = true;
        state.valid = valid;
      }

      if (changed) this.setState(state);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.focusOnMount && typeof this.ref !== 'undefined') {
        this.ref.focus();
      }

      if (this.props.trim && this.props.value) {
        this.setState({
          value: (0, _trim.default)(this.props.value)
        });
      }
    }
  }, {
    key: "id",
    get: function get() {
      return this.props.id || this._id || (this._id = _underscore.default.uniqueId('input-field-'));
    }
  }, {
    key: "className",
    get: function get() {
      var additionalClassNames = '';

      if (this.props.readOnly) {
        additionalClassNames = ' read-only';
      } else {
        if (this.props.required) {
          additionalClassNames = ' required';
        }

        if (this.state.visited && typeof this.state.valid !== 'undefined') {
          if (this.state.blurred) {
            additionalClassNames += ' ' + (this.state.valid ? '' : 'has-error');
          }

          additionalClassNames += ' ' + (this.state.valid ? 'has-success' : 'error-queue');
        }
      }

      return "form-group input-field ".concat(this.props.className + additionalClassNames);
    }
  }, {
    key: "placeholder",
    get: function get() {
      if (this.props.labelAsPlaceHolder && (this.props.label || '') !== '') {
        return this.props.label;
      } else if ((this.props.placeholder || '') !== '') {
        return this.props.placeholder;
      }

      return undefined;
    }
  }, {
    key: "rows",
    get: function get() {
      if (this.props.type === 'textarea' && typeof this.props.values === 'undefined') {
        return this.props.rows;
      }

      return undefined;
    }
  }, {
    key: "maxLength",
    get: function get() {
      if (typeof this.props.values === 'undefined') {
        return this.props.maxLength;
      }

      return undefined;
    }
  }, {
    key: "valid",
    get: function get() {
      if (_underscore.default.isUndefined(this.state.valid)) return false;
      if (_underscore.default.isFunction(this.state.valid)) return !this.props.required || this.state.valid(this.state.value);
      return this.state.valid;
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      var _this2 = this;

      // on some fields e is an Event and others (like the Select), its the
      // option they selected, so in that scenario we'd get the value from
      // e.value instead of e.target.value. but also the option value is
      // optional, in which case we want to use the option label
      if (!e) {
        this.setState({
          value: ''
        });
        return;
      }

      var optValue = typeof e.value === 'undefined' ? e.label : e.value;
      var _e$target = e.target;
      _e$target = _e$target === void 0 ? {} : _e$target;
      var _e$target$value = _e$target.value,
          value = _e$target$value === void 0 ? optValue : _e$target$value;
      this.setState({
        value: value
      }, function () {
        _this2.props.onChange(value, e);
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      this.setState({
        blurred: true,
        errorQueue: false
      }); // when props.trim is set to true, the input should be trimmed on blur.
      // onChange() is called here to change the props.value, since onBlur()
      // happens after onChange() and the trimmed value wasn't updated in props.

      if (this.props.trim) {
        var trimmedValue = (0, _trim.default)(this.props.value);

        if (trimmedValue.length === 0 && this.props.required) {
          this.setState({
            valid: false
          });
        }

        var event = {
          target: {
            value: trimmedValue
          }
        };
        this.onChange(event);
      }

      this.props.onBlur(e);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      this.setState({
        visited: true,
        blurred: false,
        errorQueue: true
      });
      this.props.onFocus(e);
    }
  }, {
    key: "getValidationState",
    value: function getValidationState() {
      if (this.state.visited && typeof this.state.valid !== 'undefined' && this.valid) {
        return _Validation.STATUS.success;
      }

      if (this.state.visited && typeof this.state.valid !== 'undefined' && !this.valid) {
        return _Validation.STATUS.error;
      }

      return undefined;
    }
  }, {
    key: "showVisualQueue",
    value: function showVisualQueue(isSelect) {
      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          showValidationIcon = _this$props.showValidationIcon,
          required = _this$props.required,
          labelAsPlaceHolder = _this$props.labelAsPlaceHolder;

      if (isSelect || readOnly) {
        return false;
      }

      if (showValidationIcon) {
        return true;
      }

      return required && labelAsPlaceHolder;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var props = {
        onChange: this.onChange,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        value: this.state.value,
        name: this.state.name,
        id: this.id,
        placeholder: this.placeholder,
        'aria-label': this.props['aria-label'] || this.placeholder,
        required: this.props.required,
        showValidationIcon: this.props.showValidationIcon,
        maxLength: this.maxLength,
        rows: this.rows,
        size: this.props.size,
        style: this.props.style,
        className: 'form-control',
        readOnly: this.props.readOnly,
        ref: function ref(_ref2) {
          _this3.ref = _ref2;
        }
      };

      var ariaProps = _underscore.default.pick(this.props, function (v, k) {
        return k !== 'aria-label' && k.indexOf('aria-') === 0;
      });

      _underscore.default.each(ariaProps, function (v, k) {
        return props[k] = v;
      });

      var Component = this.props.component || null;
      var isSelect = typeof (this.props.options || this.props.values) !== 'undefined' || this.props.type === 'select';
      var validationState = this.getValidationState();
      var showValidation = this.showVisualQueue(isSelect);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: this.className,
        onFocus: function onFocus() {
          return _this3.setState({
            focused: true
          });
        },
        onBlur: function onBlur() {
          return _this3.setState({
            focused: false
          });
        }
      }, (this.props.label || '') !== '' && !this.props.labelAsPlaceHolder && /*#__PURE__*/_react.default.createElement("label", {
        htmlFor: this.id
      }, this.props.label), (this.placeholder || '') !== '' && typeof this.props.values !== 'undefined' && (this.state.value || '') === '' && !isSelect && /*#__PURE__*/_react.default.createElement("span", {
        className: "placeholder",
        "aria-hidden": "true"
      }, this.placeholder), /*#__PURE__*/_react.default.createElement("div", {
        className: "input-field-wrapper"
      }, !isSelect && this.props.type === 'textarea' && /*#__PURE__*/_react.default.createElement(_TextArea.default, (0, _extends2.default)({}, _underscore.default.pick(this.props, _underscore.default.keys(_TextArea.default.propTypes)), props)), !isSelect && this.props.type !== 'textarea' &&
      /*#__PURE__*/

      /*
      un-setting aria-label because we have a placeholder value and
      when we define both placeholder and aria-label on this field,
      it reads out (using "Foo" as the placeholder/aria-label value)
      "Foo with hint Foo. Edit Text." rather than just "Foo. Edit Text."
      But some fields like the TextArea still needed the aria-label
      because it apparently doesn't read the placeholder
      */
      _react.default.createElement("input", (0, _extends2.default)({
        type: this.props.type
      }, props, {
        "aria-label": props['aria-label'] === props.placeholder ? undefined : props['aria-label']
      })), isSelect && (Component = Component || _Select.default) && /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, _underscore.default.omit(this.props, InputField.propTypes), {
        options: this.props.options || this.props.values,
        labelKey: "label",
        valueKey: "value",
        placeHolder: this.props.labelAsPlaceHolder ? this.props.label : undefined,
        showValidationState: this.props.showValidationIcon,
        validationState: validationState
      }, props, {
        size: undefined,
        type: undefined
      })), showValidation && /*#__PURE__*/_react.default.createElement("span", {
        className: "visual-queue".concat(!isSelect && this.props.type === 'textarea' ? ' visual-queue-textarea' : ''),
        "aria-hidden": "true"
      }, (!this.state.visited || typeof this.state.valid === 'undefined') && /*#__PURE__*/_react.default.createElement("span", null, "*"), validationState === _Validation.STATUS.success && /*#__PURE__*/_react.default.createElement(_check.default, null), validationState === _Validation.STATUS.error && /*#__PURE__*/_react.default.createElement(_warning.default, null)), this.props.readOnly && !isSelect && /*#__PURE__*/_react.default.createElement("span", {
        className: "visual-queue".concat(typeof this.props.values === 'undefined' && this.props.type === 'textarea' ? ' visual-queue-textarea' : ''),
        "aria-hidden": "true"
      }, /*#__PURE__*/_react.default.createElement(_security.default, null))), this.props.errorMessage && this.props.errorMessage.length > 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        className: "error-overlay",
        show: this.state.errorQueue && this.state.visited && typeof this.state.valid !== 'undefined' && !this.valid,
        container: this,
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
        className: "error-tooltip",
        id: "error-tooltip-for-".concat(this.state.name),
        placement: "top",
        title: this.props.errorTitle === null ? "Error in ".concat(this.props.label) : this.props.errorTitle
      }, this.props.errorMessage)), this.props.validationMessage && this.props.validationMessage.length > 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        className: "error-overlay",
        show: !this.valid && this.props.validationState !== _Validation.STATUS.error,
        container: this,
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
        className: "error-tooltip",
        id: "error-tooltip-for-".concat(this.state.name),
        placement: "top",
        title: this.props.errorTitle === null ? "Error in ".concat(this.props.name) : this.props.errorTitle
      }, this.props.validationMessage)), this.props.children);
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return _objectSpread(_objectSpread({}, _TextArea.default.propTypes), {}, {
        value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
        name: _propTypes.default.string,
        label: _propTypes.default.string,
        labelAsPlaceHolder: _propTypes.default.bool,
        showValidationIcon: _propTypes.default.bool,
        placeholder: _propTypes.default.string,
        className: _propTypes.default.string,
        required: _propTypes.default.bool,
        validateEmpty: _propTypes.default.bool,
        valid: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
        type: _propTypes.default.oneOf(['text', 'textarea', 'password', 'email', 'number', 'select']),
        rows: _propTypes.default.number,
        maxLength: _propTypes.default.number,
        size: _propTypes.default.number,
        style: _propTypes.default.object,
        values: _propTypes.default.arrayOf(_propTypes.default.shape({
          label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).required,
          value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
        })),
        focusOnMount: _propTypes.default.bool,
        onChange: _propTypes.default.func,
        onBlur: _propTypes.default.func,
        onFocus: _propTypes.default.func,
        errorTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
        errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
        validationState: _propTypes.default.string,
        validationMessage: _propTypes.default.string,
        readOnly: _propTypes.default.bool,
        trim: _propTypes.default.bool
      });
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return _objectSpread(_objectSpread({}, _TextArea.default.defaultProps), {}, {
        value: '',
        name: 'input-field',
        labelAsPlaceHolder: false,
        showValidationIcon: false,
        className: '',
        required: false,
        type: 'text',
        focusOnMount: false,
        onChange: function onChange() {},
        onBlur: function onBlur() {},
        onFocus: function onFocus() {},
        errorTitle: null,
        readOnly: false,
        trim: false,
        validateEmpty: false
      });
    }
  }]);
  return InputField;
}(_react.Component);

exports.default = InputField;